// betawww.yuankong-ai.com 测试
// yuankongai  正式 
let domainName = {}
if (window.location.origin == 'https://betawww.yuankong-ai.com' || process.env.NODE_ENV == 'development') { //测试和开发
    domainName = {
        api1: 'https://betawww.yuankong-ai.com',
        api3: 'https://betaagent.yuankong-ai.com', //测试
        api4: "http://18.246.191.34:8100", ///
        api5: "https://betaaicanvas.yuankong-ai.com",
        api6: "https://betaapp.yuankong-ai.com",
        api7: "https://betaagent.yuankong-ai.com",
        // api8: "https://betasheet.yuankong-ai.com",
        api8: "https://betawww.yuankong-ai.com/sheet",
        // api9: "https://betaworkspace.yuankong-ai.com",
        api9: "https://betawww.yuankong-ai.com/workspace",

        api10: "https://betawww.yuankong-ai.com/m",
        api11: "https://www.chatexcel.com/blog",
        api12: "https://betaopen.yuankong-ai.com",
        api13: "https://chatdata.io",

    }
} else {
    domainName = {
        api1: 'https://www.chatexcel.com',
        api3: 'https://agent.chatexcel.com', //测试
        api4: "http://18.246.191.34:8100", ///
        api5: "https://aicanvas.chatexcel.com",
        api6: "https://app.chatexcel.com",
        api7: "https://agent.chatexcel.com",
        // api8: "https://sheet.chatexcel.com",
        api8: "https://www.chatexcel.com/sheet",
        // api9: "https://workspace.chatexcel.com",
        api9: "https://www.chatexcel.com/workspace",
        api10: "https://www.chatexcel.com/m",
        api11: "https://www.chatexcel.com/blog",
        api12: "https://open.chatexcel.com",
        api13: "https://hidata.ai",

    }
}
export { domainName }